import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import MyAccordion from "../../../controls/MyAccordion/MyAccordion.mjs";
import appLib from "../../../libs/appLib.mjs";
import MultiColumnBrowserContainer from "../../../controls/MultiColumnBrowser/MultiColumnBrowserContainer.mjs";
import MultiColumnBrowserColumn from "../../../controls/MultiColumnBrowser/MultiColumnBrowserColumn.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import SimulationFlowSettings1Modal from "./SimulationFlowSettings1Modal.mjs";
import {Button, Table} from "reactstrap";
import AppFlagFalseIcon from "../../../media/app-images/AppFlagFalseIcon.mjs";
import AppFlagTrueIcon from "../../../media/app-images/AppFlagTrueIcon.mjs";
import AppPalleIcon from "../../../media/app-images/AppPalleIcon.mjs";
import FullScreenModal from "../../../controls/FullScreen/FullScreenModal.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import PeriGraphic from "../../../ComponentParts/Perimeters/PeriGraphic.mjs";

const prefix = "SimulationFlowSettings1";

const MyCart = class extends Component {
	constructor(props) {
		super(props);
		const data = Object.values(props.data||{})
			.filter( x => x && typeof x === 'object' && Object.keys(x).length > 0)
			.sort( (a,b) => a.label.localeCompare(b.label));
		data.sort( (a,b) => a.subjectLabel.localeCompare(b.subjectLabel));
		this.state = {
			data: data
		}
		this.onClick = this.onClick.bind(this);
	}
	onClick( x ) {
		if ( typeof this.props.onClick === 'function' ) this.props.onClick( x );
	}
	column( v ) {
		return (
			<td style={{ color: (v >=1 ? "#090" : "#900")}}>{Math.round(v*100)}%</td>
		)
	}
	render() {
		if ( ! this.state.data || ! this.state.data.length ) return null;
		return (
			<div className={"MyCart MyCart1"}>
				<Table striped>
					<thead>
					<tr>
						<th>
							<TextLabel value={"Main subject"} />
						</th>
						<th>
							<TextLabel value={"ICT good"} />
						</th>
						<th>C</th>
						<th>I</th>
						<th>A</th>
						<th>O</th>
					</tr>
					</thead>
					<tbody>
					{ this.state.data.map( b => (
						<tr
							key={ b.id }
							style={ this.props.onClick ? {cursor: "pointer"} : undefined}
							onClick={ () => this.onClick(b.id) }
						>
							<td>
								{ b.subjectLabel }
							</td>
							<td>
								{ b.label }
							</td>
							{ this.column( b.status?.c ?? 1) }
							{ this.column( b.status?.i ?? 1) }
							{ this.column( b.status?.a ?? 1) }
							{ this.column( b.status?.o ?? 1) }
						</tr>
					)) }
					</tbody>
				</Table>
			</div>
		)
	}
}

/**
 * @typedef ItemStatus
 * @private
 * @type {Object}
 * @property {Number} c
 * @property {Number} i
 * @property {Number} a
 * @property {Number} o
 */

/**
 * @typedef CartItem
 * @private
 * @type {Object}
 * @property {string} id
 * @property {string} label
 * @property {string} subject
 * @property {string} subjectLabel
 * @property {ItemStatus} status
 * @property {boolean} [new]
 * @property {Component} [icon]
 */

const SimulationFlowSettings1 = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			update: Date.now(),
			/** @type {Record<string,CartItem>} */
			cart: structuredClone(props.simul?.trigger?.saved ?? {})
		};
		this.uid = Glob.generateUid(prefix);
		this.fetchSubjects = this.fetchSubjects.bind(this);
		this.fetchBeni = this.fetchBeni.bind(this);
		this.selectedBene = this.selectedBene.bind(this);
		this.deselectBeni = this.deselectBeni.bind(this);
	}
	componentDidMount() {
		if ( super.componentDidMount ) super.componentDidMount();
		setTimeout( this.fetchSubjects );
	}
	fetchSubjects() {
		appLib.api('perimetri/list-subjects', {id: this.props.peri }).then( x => {
			const subjects = (x.result||[])
				.filter( s => !! s.main )
				.map( s => ({ label: s.name, value: s.id }));
			this.setState({ subjects: subjects });
		}).catch( err => {
			console.error( err );
		});
	}
	fetchBeni( o ) {
		const ns = { beni: [], selectedSubject: null, update: Date.now() };
		if ( ! o ) {
			this.setState(ns);
			return;
		}
		appLib.api("perimetri/list-beni", { id: this.props.peri, subject: o.value }).then( l => {
			ns.selectedSubject = o.value;
			ns.beni = (l.result||[]).map( b => ({
				label: b.name,
				value: b.id,
				disabled: !! this.state.cart[ b.id]
			}));
			ns.beni = ns.beni.map( b => {
				b.icon = b.disabled ? <AppFlagFalseIcon /> : <AppFlagTrueIcon />;
				return b;
			});
			this.setState(ns);
		})
	}
	async selectedBene(o) {
		const id = o?.value ?? o ?? false;
		/** @type CartItem */
		let bene = this.state.cart[id] ?? (this.state.beni||[]).filter( b => b.value === id ).map( b => ({
			id: b.value,
			label: b.label,
			subject: this.state.selectedSubject,
			subjectLabel: this.state.subjects.find( s => s.value === this.state.selectedSubject ).label,
			new: true,
			status: { c:1,i:1,a:1,o:1}
		}))[0];
		if ( ! bene ) {
			bene = (await appLib.api("perimetri/list-beni", { id: this.props.peri }))
				.result
				.find( b => b.id === id );
			if ( bene ) bene = {
				id: id,
				label: bene.name,
				subject: bene.subject,
				subjectLabel: this.state.subjects.find( s => s.value === bene.subject ).label,
				new: true,
				status: { c:1,i:1,a:1,o:1}
			};
		}
		if ( bene ) this.setState({ editBene: bene });
	}
	deselectBeni() {
		const ns = { update: Date.now(), useGraphicSelector: false };
		if ( this.state.beni ) {
			ns.beni = this.state.beni.map( b => {
				delete b.selected;
				b.disabled = !! this.state.cart[b.value];
				b.icon = b.disabled ? <AppFlagFalseIcon /> : <AppFlagTrueIcon />;
				return b;
			});
		}
		this.setState(ns, () => {
			//if(Object.keys(this.state.cart).length > 0) this.props.canSave(true);
			//this.props.canSave(true)
			this.props.changed(this.state.cart);
		});
	}
	render() {
		if ( ! this.state.subjects ) return null;
		// console.log( this.state.cart );
		return (
			<>
				<div className={prefix + ' limited'}>
					<MyAccordion title={"Use case 1"}>
						A partire dalla compromissione di uno o più beni ICT, segnalata da una notifica di incidente, vengono analizzati in logica worst case i possibili impatti a cascata su soggetti e beni PSNC.
					</MyAccordion>
					{ (! this.props.did?.run) && (
						<>
							<div className={"mt-2 mb-2 text-end"}>
								<Button
									color={"success"}
									className={"btn-icon"}
									onClick={ ()=>{ this.setState({ useGraphicSelector: true })} }
								>
									<b>
										<TextLabel value={"Graphic selector"} />
									</b>
									<i>
										<AppPalleIcon />
									</i>
								</Button>
							</div>
							<MultiColumnBrowserContainer
								style={{height: 'min(50vh,320px)',resize:'unset'}}
							>
								<MultiColumnBrowserColumn
									options={ this.state.subjects}
									title={ <TextLabel value={"Main subjects"} /> }
									onClick={ this.fetchBeni }
									width={"50%"}
									filter={Glob.label('Filter')}
								/>
								<MultiColumnBrowserColumn
									key={ 'beni'+this.state.update }
									title={ <TextLabel value={"ICT goods"} /> }
									options={ this.state.beni }
									onClick={ this.selectedBene }
									width={"50%"}
									filter={Glob.label('Filter')}
								/>
							</MultiColumnBrowserContainer>
							{ (!!this.state.editBene) && (
								<SimulationFlowSettings1Modal
									bene={ this.state.editBene }
									close={ ()=>{ this.setState({ editBene: null }, this.deselectBeni) }}
									save={ (o)=>{
										const cart = this.state.cart;
										cart[o.id] = {
											id: o.id,
											label: o.label,
											subject: o.subject,
											subjectLabel: o.subjectLabel,
											status: o.status
										};
										this.setState({ cart: cart, editBene: null, canSave: true }, this.deselectBeni);
									}}
									remove={ (o)=>{
										const cart = this.state.cart;
										delete cart[o.id];
										this.setState({ cart: cart, editBene: null, canSave: true }, this.deselectBeni);
									}}
								/>
							)}
							{ this.state.useGraphicSelector && (
								<FullScreenModal
									title={ <>{ this.props.simul.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> } <span>{this.props.simul.info.periname}</span></> }
									toggle={ ()=>{ this.setState({ useGraphicSelector: false } ) }}
								>
									<PeriGraphic
										id={ this.props.simul.info.peri }
										highlighted={ Object.keys(this.state.cart || {}) }
										onNodeClick={ async (node, pc ) => {
											const nd = node.data();
											if ( nd.type !== 'BeneICT' ) return false;
											const ans = await this.selectedBene(nd.id);
											console.log( ans );
										}}
									/>
								</FullScreenModal>
							)}
						</>
					)}
				</div>
				<MyCart
					key={ 'cart'+this.state.update }
					data={ this.state.cart }
					onClick={ this.props.did?.run ? undefined: this.selectedBene }
				/>
			</>
		)
	}
}

export default SimulationFlowSettings1;